
import { MessageTone } from "@/types/message";
import { type Toast } from "@/components/ui/use-toast";

/**
 * Provides toast notification helpers for the regeneration process
 */
export const useToastNotifications = (toast: (props: Omit<Toast, "id">) => void) => {
  const showRegenerationStarted = (tone: MessageTone, customInstructions?: string) => {
    toast({
      title: "Regenerating response",
      description: tone === "custom" 
        ? "Our AI is crafting a response with your custom instructions..."
        : `Our AI is crafting a new ${tone} response...`,
    });
  };
  
  const showRegenerationSuccess = (tone: MessageTone, customInstructions?: string) => {
    toast({
      title: "Response regenerated",
      description: tone === "custom"
        ? "Your response has been regenerated with your custom instructions."
        : `Your response has been regenerated with a ${tone} tone.`,
      variant: "default"
    });
  };
  
  const showRegenerationError = (error: any) => {
    console.error("Error regenerating response:", error);
    toast({
      variant: "destructive",
      title: "Error regenerating response",
      description: error.message || "Failed to regenerate response.",
    });
  };
  
  return {
    showRegenerationStarted,
    showRegenerationSuccess,
    showRegenerationError
  };
};
